import { saveAs } from "file-saver";
import { Document, Packer, Paragraph, TextRun, SectionType } from "docx";

function exportDocs(messages) {
  console.log("from utils", messages);
  var formattedDoc = [];
  for (var message of messages) {
    var para = new Paragraph({
      children: [
        new TextRun({
          text: message.speaker.name + ": ",
          bold: true,
          color: "ffffff",
        }),
        new TextRun({ text: message.text, color: "ffffff" }),
      ],
    });
    formattedDoc.push(para);
  }
  const doc = new Document({
    sections: [
      {
        properties: { type: SectionType.CONTINUOUS },
        children: formattedDoc,
      },
    ],
  });

  var today = getDate();
  const fileName = "Minutes_" + today + ".docx";
  console.log("fileName", fileName);

  Packer.toBlob(doc).then((blob) => {
    console.log(blob);
    saveAs(blob, fileName);
    console.log("Document created successfully");
  });
}

function getDate() {
  var today = new Date();
  var dd = today.getDate();
  var mm = today.getMonth() + 1;
  var yyyy = today.getFullYear();

  if (dd < 10) {
    dd = "0" + dd;
  }

  if (mm < 10) {
    mm = "0" + mm;
  }

  today = dd + "/" + mm + "/" + yyyy;
  return today;
}

export default exportDocs;
